import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import TimelineNavigator from "../../../navigation/TimelineNavigator";
import styles from "./timeline.module.css";

const Timeline = () => {
  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          <div className={styles.linkWrapper}>
            <PageLink destination="/dashboard/timelines/show-all-timelines">
              عرض جميع الجداول الزمنية
            </PageLink>
          </div>
        </div>
      </HorizantalBar>
      <TimelineNavigator />
    </div>
  );
};

export default Timeline;
